<template>
   <section class="home-markets">
    <div class="tab">
      <span class="tab-item defaultFamily" :class="{'active': active === 'main'}" @click="check('main')">{{$t('home_v2_80')}}</span>
      <span class="tab-item defaultFamily" :class="{'active': active === 'new'}" @click="check('new')">{{$t('home_v2_17')}}</span>
      <span class="tab-item defaultFamily" :class="{'active': active === 'increase'}"
            @click="check('increase')">{{$t('home_v2_18')}}</span>
    </div>
    <div class="market-table">
      <table border="0" cellpadding="0">
        <thead>
        <td class="td_width231 title td_width33 firstLeft">{{$t('home_51')}}</td>
        <td class="td_width231 title td_width28">{{$t('coin_lastPrice')}}</td>
        <td class="td_width316 title td_width25">{{$t('coin_changeIn24h')}}</td>
        <td v-if="active === 'increase'" class="web title">{{$t('perpetual_46')}}</td>
        <td v-else class="web td_width316 title">{{$t('coin_turnover24h')}}</td>
        <!-- <td class="iphone">{{$t('home_61')}}</td> -->
        </thead>
        <tbody>
        <tr v-for="(rowItem, index) in pairInfoData" :key="index" @click.prevent="goSpot(rowItem.busitype)"
            v-show="index < 5">
          <td class="firstLeft">
            <i :style="`background-image: url(https://event.bitforex.com/assets/coin/${rowItem.showName}m.png)`"></i>
            <strong v-if="active !== 'increase'">{{tokenName(rowItem.showName)}}</strong>
            <span v-if="active !== 'increase'">{{rowItem.showName}}</span>
            <strong v-if="active === 'increase'">{{rowItem.showName}}</strong>
            <span v-if="active === 'increase'">/ {{rowItem.commodity}}</span>
          </td>
          <template v-if="active !== 'increase'">
            <!-- {{rowItem.lastUsdPrice}} -->
            <td>{{currentCurrency.symbol}}{{ rowItem.lastUsdPrice | filterCurrency(currentCurrency, 2) | toNumber |
              toNonExponential | formatMoney }}
            </td>
          </template>
          <template v-else>
            <td>{{ rowItem.last | formatNumber(rowItem.pricePrecision, false) | toNumber | toNonExponential |
              formatMoney }}
            </td>
          </template>
          <td :class="rowItem.float * 1 < 0 ? 'dw' : 'up'">
            <div class="light-bg">{{rowItem.float * 1 > 0 ? '+' : ''}} {{(rowItem.float * 100).toFixed(2).replace('-', '- ')}}%</div>
          </td>
          <template v-if="active !== 'increase'" class="web">
            <td v-if="active !== 'increase'" class="web">{{currentCurrency.symbol}}{{rowItem.cvolUsdPrice | filterCurrency(currentCurrency, 2) | formatMoney}}
            </td>
            <td v-else class="web ">{{rowItem.cvolUsdPrice | filterCurrency(currentCurrency, 2) | formatMoney}}
              {{ rowItem.units }}
            </td>
          </template >
          <template v-else class="web">
            <td class="web">
              <span >{{checkNumber(rowItem.vol) }} </span> <span>   {{
              rowItem.units }}</span>
            </td>
          </template>
          <td class="iphone buys lastRight"><div class="buy">{{$t('borrow_36')}}</div></td>
        </tr>
        </tbody>
      </table>
       <a :href="active === 1 ? `/${locale}/perpetual` : `/${locale}/spot/btc_usdt`" class="more">
        {{ $t('coin_more') }}
        <svg class="moreRight ficon">
          <use xlink:href="#bf-arrow-right-s-line" />
        </svg>
      </a>
    </div>
  </section>
</template>

<script>
  import {
    // eslint-disable-next-line no-unused-vars
    searchTickersV2, getKLinV1, getECurrencyExchangeRate, searchTickers
  } from '~/model/clientTradeModel';
  // eslint-disable-next-line no-unused-vars
  import {sortBy, filterCommodity, formatInputNum} from '~/utils/util';
  import {mapState, mapGetters, mapActions} from 'vuex';
  import ChartLine from './../chart/chart-line.vue';
  // eslint-disable-next-line import/no-duplicates
  import Big from 'big.js';

  export default {
    name: 'HomeMarkets',
    components: {ChartLine},
    data () {
      return {
        active: 'main',
        usdtUsdRate: 0,
        usdcUsdRate: 0,
        allTickerList: [],
        tickerList: {
          main: [],
          new: [],
          increase: []
        },
        allTickersTimer: null,
        sortList: ['btc', 'eth', 'omi', 'xzc', 'mwc', 'grin', 'beam', 'ltc', 'xrp', 'xlm'],
        pairShowList: [] // 从pairListNew筛选后的树
        // pairInfoData: {} // 交易对ticker
      };
    },
    computed: {
      ...mapState({
        locale: state => state.common.locale,
        currentCurrency: state => state.common.currentCurrency,
        isLogin: state => state.user.isLogin,
        valuationSymbol: state => state.common.valuationSymbol,
        valuationCurrency: state => state.common.valuationCurrency,
        contract_all_tickers: state => state.perpetual.contract_all_tickers
      }),
      ...mapGetters('perpetual', ['contractList']),
      pairInfoData () {
        return this.tickerList[this.active];
      }
    },
    watch: {
      active () {
        // this.getPairInfoData('main');
        // this.getPairInfoData('new');
        // this.getPairInfoData('increase');
      }
    },
    created () {
    },
    async mounted () {
      await this.getUsdtUsdExchangeRate();
      await this.searchTickers();
      this.getPairInfoData('main');
      this.getPairInfoData('new');
      this.getPairInfoData('increase');

      this.contractList.length || this.getContractAllInfo();
      this.getContractAllTickers();
    },
    methods: {
      ...mapActions('perpetual', ['getContractAllInfo', 'getContractAllTickers']),
      tokenName (coin) {
        const list = {
          'BTC': 'Bitcoin',
          'ETH': 'Ethereum',
          'LTC': 'Litecoin',
          'BCH': 'Bitcoin Cash',
          'GRIN': 'Grin',
          'ADA': 'Cardano',
          'XRP': 'Ripple',
          'OMI': 'Ecomi',
          'DOT': 'Polkadot',
          'DOGE': 'Dogecoin',
          'TRX': 'TRON',
          'SOLO': 'Sologenic',
          'BEAM': 'Beam'
        };
        return list[coin] || coin;
      },
      async searchTickers () {
        let result = (await searchTickers({type: 'all'}));
        if (result.success) {
          this.allTickerList = result.data;
        }
      },
      async getUsdtUsdExchangeRate () {
        let result = (await getECurrencyExchangeRate({
          ecurrency: 'usdt',
          currency: 'usd'
        })).data;
        this.usdtUsdRate = result;
      },
      check (val) {
        this.active = val;
      },
      // spot
      goSpot (symbol) {
        let codeType = symbol.toLowerCase().split('-');
        this.$router.push({
          path: '/spot/' + codeType[2] + '_' + codeType[1]
        });
      },
      // 获取交易对ticker
      getPairInfoData (type) {
        searchTickersV2({type: type}).then(async res => {
          if (res.success === true) {
            const newdata = res.data;
            let newArr = [];
            for (let item of newdata) {
              if (item) {
                item.showName = filterCommodity(item.busitype.split('-')[2].toUpperCase());
                item.unit = item.busitype.split('-')[1].toUpperCase();
                item.showUsdValue = false;
                // if (type === 'main' || type === 'new') {
                // 主流币和创新区的币对值转换为usd值，如果汇率加载失败，则查询其与usdt币对的价格，取到usdt价格后将usdt价格转换为usd显示
                if (this.usdtUsdRate) {
                  // 如果已成功加载usdtusd汇率，则对币对进行usdt转换
                  if (item.busitype.split('-')[1] === 'usdt') {
                    // console.log(item.busitype.split('-'));
                    // this.$log(`查询到本身为usdt币对${item.busitype}`);
                    item.showUsdValue = true;
                    item.lastUsdPrice = new Big(item.last).times(this.usdtUsdRate).valueOf();
                    item.cvolUsdPrice = new Big(item.cvol).times(this.usdtUsdRate).valueOf();
                    item.unit = '$';
                    item.units = item.busitype.split('-')[2].toUpperCase();
                  } else if (item.busitype.split('-')[1] === 'usdc') {
                    // console.log(item.busitype.split('-'));
                    // this.$log(`查询到本身为usdt币对${item.busitype}`);
                    item.showUsdValue = true;
                    item.lastUsdPrice = new Big(item.last).times(this.usdtUsdRate).valueOf();
                    item.cvolUsdPrice = new Big(item.cvol).times(this.usdtUsdRate).valueOf();
                    item.unit = '$';
                    item.units = item.busitype.split('-')[2].toUpperCase();
                  } else {
                    let usdtTicker = this.allTickerList[`coin-usdt-${item.busitype.split('-')[1]}`];
                    if (usdtTicker) {
                      // 如果查询到usdt的交易对，则将最新价及24小时成交额替换为该币对的相关值
                      // this.$log(`查询到原始币对：${item.busitype}的usdt交易对${usdtTicker.busitype}`);
                      item.showUsdValue = true;
                      item.lastUsdPrice = new Big(usdtTicker.last).times(item.last).times(this.usdtUsdRate).valueOf();
                      item.cvolUsdPrice = new Big(usdtTicker.last).times(item.cvol).times(this.usdtUsdRate).valueOf();
                      item.units = item.busitype.split('-')[2].toUpperCase();
                      item.unit = '$';
                    } else {
                      // this.$log(`未查询到原始币对：${item.busitype}的usdt交易对`);
                    }
                  }
                }
                // }
                item.commodity = item.busitype.split('-')[1].toUpperCase();
                // console.log(item);
                newArr.push(item);
              }
            }
            for (let index in newArr) {
              let item = newArr[index];
              item.klineArr = [];
              if (index <= 5) {
                getKLinV1(
                  item.busitype,
                  '30min',
                  '48'
                ).then((klineResult) => {
                  if (klineResult.success) {
                    for (let i of klineResult.data) {
                      if (i) {
                        item.klineArr.push(i.close);
                      }
                    }
                  }
                });
              }
            }
            // this.pairInfoData = newArr;
            this.tickerList[type] = newArr;
          }
        });
      },
      // 百万十亿变成M和B
      checkNumber (val) {
        if ( val < 1000000 ) {
          return val;
        } else if ( val >= 1000000 && val < 1000000000 ) {
          const num = val / 1000000;
          const nums = formatInputNum(num, 2);
          return nums + 'M';
        } else if ( val >= 1000000000 ) {
          const num = val / 1000000000;
          const nums = formatInputNum(num, 2);
          return nums + 'B';
        }
      },
      allTickersInterval () {
        this.allTickersTimer && clearInterval(this.allTickersTimer);
        this.allTickersTimer = setInterval(() => {
          this.getPairInfoData();
        }, 15000);
      },
      // perpetual
      goPerpetual (val) {
        this.$router.push({path: `/perpetual/${val.alias.toLowerCase().replace('/', '_')}`});
      },
      getLast (symbol) {
        if (this.contract_all_tickers[symbol]) {
          return this.contract_all_tickers[symbol].last * 1;
        } else {
          return 0;
        }
      },
      getFloat (symbol) {
        if (this.contract_all_tickers[symbol]) {
          return (this.contract_all_tickers[symbol].rate * 100).toFixed(2) * 1;
        } else {
          return 0;
        }
      },
      getHigh (symbol) {
        if (this.contract_all_tickers[symbol]) {
          return this.contract_all_tickers[symbol].high * 1;
        } else {
          return 0;
        }
      },
      getLow (symbol) {
        if (this.contract_all_tickers[symbol]) {
          return this.contract_all_tickers[symbol].low * 1;
        } else {
          return 0;
        }
      },
      getCvol (symbol) {
        if (this.contract_all_tickers[symbol]) {
          return (this.contract_all_tickers[symbol].productvol * 1).toFixed(2); // allVol
        } else {
          return 0;
        }
      }
    },
    beforeDestroy () {
      this.allTickersTimer && clearInterval(this.allTickersTimer);
    }
  };
</script>

<style lang="scss" scoped>

  @import "./markets.scss";

</style>
